import type { ComponentType } from 'react';

import type { useAppForm } from '@/shared/ui/form';

import { ProductSentimentFormBody } from './product-sentiment-topic/ui';

type TemplateFormBody = ComponentType<{
  form: ReturnType<typeof useAppForm>;
}>;

const TEMPLATE_FORM_BODY_MAP: Record<string, TemplateFormBody> = {
  'product-sentiment-topic': ProductSentimentFormBody as unknown as TemplateFormBody,
};

export const getTemplateFormBody = (templateId: string): TemplateFormBody => {
  return TEMPLATE_FORM_BODY_MAP[templateId] ?? ProductSentimentFormBody;
};
